import React, { useState } from "react";

const ParkrunFeedback = () => {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState<any>({
    event: "",
    role: "",
    surface: "",
    accuracy: "",
    comments: ""
  });

  const handleSubmit = async (e:any) => {
  e.preventDefault();

  try {
    const payload = {
      ...form,
      timestamp: new Date().toISOString()
    };
    const res = await fetch("https://asdry-engine-v1.onrender.com/api/feedback", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const text = await res.text();
      console.error("Feedback API error:", text);
      throw new Error("Feedback API request failed");
    }

    let data: any = null;

    const text = await res.text();
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = { status: "stored", raw: text };
      }
    } else {
      data = { status: "stored" };
    }

    console.log("Feedback stored:", data);
    setSubmitted(true);
    setForm({
      event: "",
      role: "",
      surface: "",
      accuracy: "",
      comments: ""
    });

  } catch (err) {
    console.error("Feedback error:", err);
  }
};

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm((prev: any) => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="content-card">
          <div className="card-header">
            <h1 className="content-title">Parkrun Environmental Feedback</h1>
            <p className="content-description">
              If you ran or volunteered at one of the events, your observations help
              validate and improve the ASDRY environmental preparation engine.
            </p>
          </div>

          <div className="card-body">
            {submitted && (
              <div className="feedback-success">
                ✓ Thank you — your feedback helps improve the environmental model.
              </div>
            )}
            <form onSubmit={handleSubmit} className="feedback-form">

          <div className="form-group">
            <label>Event</label>
            <select name="event" value={form.event} onChange={handleChange} required>
              <option value="">Select event</option>
              <option value="Markeaton">Markeaton</option>
              <option value="Alvaston">Alvaston</option>
              <option value="Ashbourne">Ashbourne</option>
              <option value="Trentham">Trentham</option>
            </select>
          </div>

          <div className="form-group">
            <label>Role</label>
            <select name="role" value={form.role} onChange={handleChange} required>
              <option value="">Select role</option>
              <option value="Runner">Runner</option>
              <option value="Volunteer">Volunteer</option>
              <option value="Spectator">Spectator</option>
            </select>
          </div>

          <div className="form-group">
            <label>Surface conditions</label>
            <select name="surface" value={form.surface} onChange={handleChange} required>
              <option value="">Select condition</option>
              <option value="Very dry">Very dry</option>
              <option value="Dry">Dry</option>
              <option value="Slightly damp">Slightly damp</option>
              <option value="Wet">Wet</option>
              <option value="Muddy">Muddy</option>
            </select>
          </div>

          <div className="form-group">
            <label>Accuracy of report</label>
            <select name="accuracy" value={form.accuracy} onChange={handleChange} required>
              <option value="">Select accuracy</option>
              <option value="Very accurate">Very accurate</option>
              <option value="Mostly accurate">Mostly accurate</option>
              <option value="Partly accurate">Partly accurate</option>
              <option value="Not accurate">Not accurate</option>
            </select>
          </div>

          <div className="form-group">
            <label>Comments</label>
            <textarea
              name="comments"
              value={form.comments}
              onChange={handleChange}
              placeholder="Optional observations about conditions"
              maxLength={500}
            />
          </div>

          <input
            type="text"
            name="website"
            style={{ display: "none" }}
            tabIndex={-1}
            autoComplete="off"
          />

          <button type="submit" className="feedback-submit">Submit Environmental Feedback</button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParkrunFeedback;